import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import Tilt from "react-parallax-tilt";
import ImageViewer from "react-simple-image-viewer";
import { images } from "../../common/data/images.list";

const Products: React.FC = () => {
  const { t } = useTranslation(["common"]);
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index: number) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <>
      {isViewerOpen && (
        <ImageViewer
          backgroundStyle={{ zIndex: 20 }}
          src={images}
          currentIndex={currentImage}
          disableScroll={false}
          closeOnClickOutside={true}
          onClose={closeImageViewer}
        />
      )}
      <main
        id="products"
        className="min-h-screen flex items-center justify-center bg-gray-50"
      >
        <div className="container mx-auto">
          <div className="px-3 md:py-12 py-8">
            <div>
              <h1 className="text-3xl lg:text-4xl font-semibold text-gray-800 text-center">
                {t("products")}
              </h1>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mt-8 md:mt-10">
              {images.map((item, key) => (
                <Tilt
                  className="parallax-effect-glare-scale"
                  perspective={1000}
                  glareEnable={true}
                  glareMaxOpacity={0.45}
                  scale={1.01}
                >
                  <div
                    onClick={() => openImageViewer(key)}
                    className="bg-white shadow-xl hover:scale-105 duration-300 shadow-gray-100 relative rounded-lg p-8 cursor-pointer"
                  >
                    <div className="flex justify-center items-center">
                      <img src={item} alt="haryt" />
                    </div>
                  </div>
                </Tilt>
              ))}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Products;
